import _ from "lodash";
import {PRODUCT_DETAIL_KEY} from "../constants/pod.constant";

export {
    prepareProductsForAddOrUpdate
};

const prepareProductsForAddOrUpdate = (latestProductsList, existingProductsList) => {
    const processedProducts = {
        add: [],
        update: []
    };

    const existingProductsMap = _.keyBy(existingProductsList, PRODUCT_DETAIL_KEY.VARIANT_ID);

    _.forEach(latestProductsList, (latestProduct, index) => {
        const existingProduct = existingProductsMap[latestProduct[PRODUCT_DETAIL_KEY.VARIANT_ID]];

        if (_.isEmpty(existingProduct)) {
            processedProducts.add.push(latestProduct);
        } else {
            const updateNeeded = prepareExistingProductForUpdate(existingProduct, latestProduct);

            if (updateNeeded) {
                processedProducts.update.push(existingProduct);
            }
        }
    });

    console.log('Add Products -> : ', processedProducts.add.length);
    console.log('Update Products -> : ', processedProducts.update.length);

    return processedProducts;
}

const prepareExistingProductForUpdate = (existingProduct, latestProduct) => {
    let updateNeeded = false;
    latestProduct.id = existingProduct.id;

    _.forIn(latestProduct, (value, attribute) => {
        if (attribute !== 'id') {
            // existingProduct[attribute] = value;
            if (existingProduct.hasOwnProperty(attribute)) {
                if (existingProduct[attribute] !== value) {
                    // console.log('CHANGED: ', attribute, ' - new: ', value, ' - old: ', existingProduct[attribute]);
                    existingProduct[attribute] = value;
                    updateNeeded = true;
                }
            } else {
                existingProduct[attribute] = value;
                updateNeeded = true;
                // console.log('NEW: ', attribute, ' - ', value);
            }
        }
    });

    return updateNeeded;
}
